module.exports = __webpack_public_path__ + "static/img/ссм-logo.b29df277.svg";